<template>
  <transition name="toolbar-fade" mode="out-in">
      <ul class="toolbar" :key="type">
        <li v-if="isTextOrBlock">
          <Uselectbox type="edit" :width="100" @selected="fontName = $event.param.value" v-model="fontNameInit" :options="fontList"/>
        </li>
        <li v-if="isText">
          <Uselectbox type="edit" :width="80" @selected="fontSize = $event.param.value" v-model="fontSizeInit" :options="fontSizeList"/>
        </li>
        <li v-if="isBlock">
          <editorIconButton @click.native="style = ES.STYLE_BLOCK01" icon="218" :state="{'active': style === ES.STYLE_BLOCK01}"/>
          <editorIconButton @click.native="style = ES.STYLE_BLOCK02" icon="219" :state="{'active': style === ES.STYLE_BLOCK02}"/>
          <editorIconButton @click.native="style = ES.STYLE_BLOCK03" icon="220" :state="{'active': style === ES.STYLE_BLOCK03}"/>
          <editorIconButton @click.native="style = ES.STYLE_BLOCK04" icon="221" :state="{'active': style === ES.STYLE_BLOCK04}"/>
        </li>
        <li v-if="isTextOrBlock">
          <!-- <icon size="xsmall" uicon="edit_asterisk"/> -->
          <editorIconButton @click.native="isBold = !isBold" icon="201" :isActive="isBold" title="볼드"/>
          <editorIconButton @click.native="isItalic = !isItalic" icon="202" :isActive="isItalic" title="이텔릭"/>
          <editorIconButton @click.native="isUnderline = !isUnderline" icon="204" :isActive="isUnderline" v-if="isText" title=""/>
          <editorIconButton @click.native="isStrike = !isStrike" icon="203" :isActive="isStrike" v-if="isText"/>
        </li>
        <li v-if="isTextOrBlock">
          <Ubutton size="medium" icon="205" iconSize="xsmall" :lineStyle="hasForeColor" lineSize="small" @click.native="opencolor('txt', $event)"/>
          <Ubutton size="medium" icon="205" iconSize="xsmall" lineSize="small" :lineStyle="hasBackColor" @click.native="opencolor('bg', $event)"/>
        </li>
        <li v-if="isTextOrBlock || isTitle || isIndex">
          <editorIconButton @click.native="textAlign = ES.ALIGN_LEFT" icon="206" :isActive="textAlign === ES.ALIGN_LEFT"/>
          <editorIconButton @click.native="textAlign = ES.ALIGN_CENTER" icon="207" :isActive="textAlign === ES.ALIGN_CENTER"/>
          <editorIconButton @click.native="textAlign = ES.ALIGN_RIGHT" icon="208" :isActive="textAlign === ES.ALIGN_RIGHT"/>
          <editorIconButton @click.native="textAlign = ES.ALIGN_JUSTIFY" icon="209" :isActive="textAlign === ES.ALIGN_JUSTIFY"/>
        </li>
        <li v-if="isTextOrBlock">
          <editorIconButton v-if="isText" @click.native="isIndent = !isIndent" icon="210" :isActive="isIndent"/>
          <editorIconButton v-if="isText" icon="212" @click.native="$emit('action', null, ES.toolLINE)"/>
          <editorIconButton v-if="isText" icon="213" @click.native="$emit('action', null, ES.toolBLOCK, ES.BLOCK)"/>
          <editorIconButton @click.native="openLinkPopup" icon="215" :isActive="link !== null"/>
        </li>
        <li v-if="isText">
          <editorIconButton @click.native="document.querySelector('#imageForm #pimg').click()" icon="216"/>
        </li>
        <li v-if="isLine">
          <editorIconLineButton @click.native="style = ES.STYLE_SOLID" icon="large solid" :class="{'active': style === ES.STYLE_SOLID}"/>
          <editorIconLineButton @click.native="style = ES.STYLE_INSET" icon="large inset" :class="{'active': style === ES.STYLE_INSET}"/>
          <editorIconLineButton @click.native="style = ES.STYLE_DOUBLE" icon="large double" :class="{'active': style === ES.STYLE_DOUBLE}"/>
          <editorIconLineButton @click.native="style = ES.STYLE_DASHED" icon="large dashed" :class="{'active': style === ES.STYLE_DASHED}"/>
        </li>
        <li v-if="isLine">
          <editorIconLineButton @click.native="lineSize = ES.SIZE_SMALL" icon="small solid" :class="{'active': lineSize === ES.SIZE_SMALL}"/>
          <editorIconLineButton @click.native="lineSize = ES.SIZE_MIDDLE" icon="middle solid" :class="{'active': lineSize === ES.SIZE_MIDDLE}"/>
          <editorIconLineButton @click.native="lineSize = ES.SIZE_LARGE" icon="large solid" :class="{'active': lineSize === ES.SIZE_LARGE}"/>
        </li>
        <li v-if="isLine">
          <Ubutton size="medium" icon="205" iconSize="xsmall" :lineStyle="hasForeColor" lineSize="small" @click.native="opencolor('line', $event)"/>
        </li>
        <li v-if="isImg">
          <editorIconButton @click.native="style = ES.STYLE_FULL" icon="213" :class="{'active': style === ES.STYLE_FULL}"/>
          <editorIconButton @click.native="style = ES.STYLE_ORG" icon="214" :class="{'active': style === ES.STYLE_ORG}"/>
        </li>
        <li v-if="isLine || isImg || isBlock">
          <editorIconButton @click.native="$emit('action', null, ES.toolREMOVE)" icon="217"/>
        </li>
        <li>
          <editorIconButton @click.native="$emit('action', null, ES.toolLASTENTER)" icon="150"/>
        </li>
        <ucolor v-if="colorStyle !== null" :option.sync="colorStyle" @select="colorSelect"/>
        <form id="imageForm" class="hide" method="post" enctype="multipart/form-data" action="/api/point/withdrawal">
          <input type="file" id="pimg" name="pimg" accept="image/*" capture="camera" @change="loader.loadImg('pimg', $event.target.files[0], imageChange)">
        </form>
      </ul>
  </transition>
</template>

<script>
import UImageLoader from '@/components/js/UImageLoader.js'
import ES from '@/components/js/EditorSetting.js'
import {closest} from '@/components/js/Utils.js'

var loader = new UImageLoader()
loader.size = {width: 1200, height: 0}

export default {
  props: {
    isReFocus: { type: Boolean },
    focus: { type: Object },
    type: { type: String },
    title: { type: String },
    bold: { type: Boolean },
    italic: { type: Boolean },
    underline: { type: Boolean },
    strike: { type: Boolean },
    align: { type: String },
    indent: { type: Boolean },
    font: { type: String },
    size: { type: String },
    foreColor: { type: String },
    backColor: { type: String },
    editStyle: { type: String },
    link: { type: String },
    initBody: { type: String }
  },
  mounted () {
    document.addEventListener('mousedown', this.mousedown)
  },
  beforeDestroy () {
    document.removeEventListener('mousedown', this.mousedown)
  },
  data: function () {
    return {
      ES: ES,
      loader: loader,
      colorStyle: null,
      fontNameInit: 0,
      fontSizeInit: 2,
      fontList: [
        {id: 0, text: '나눔고딕', value: 'Nanum Gothic', css: {'font-family': 'Nanum Gothic'}},
        {id: 1, text: '나눔명조', value: 'Nanum Myeongjo', css: {'font-family': 'Nanum Myeongjo'}},
        {id: 2, text: 'KoPub 돋움체', value: 'KoPub Dotum', css: {'font-family': 'KoPub Dotum'}},
        {id: 3, text: 'KoPub 바탕체', value: 'KoPub Batang', css: {'font-family': 'KoPub Batang'}}
      ],
      fontSizeList: [
        {id: 0, text: '서체1', value: 4, css: {'font-size': 'large'}},
        {id: 1, text: '서체2', value: 3, css: {'font-size': 'medium'}},
        {id: 2, text: '서체3', value: 2, css: {'font-size': 'small'}},
        {id: 3, text: '서체4', value: 1, css: {'font-size': 'x-small'}}
      ]
    }
  },
  name: 'ToolBar',
  watch: {
    size (v) {
      console.log('changesize', v)
      if (v === null) {
        this.fontSizeInit = 2
      } else {
        for (var o in this.fontSizeList) {
          if (this.fontSizeList[o].value.toString() === this.size) {
            this.fontSizeInit = this.fontSizeList[o].id
          }
        }
      }
    },
    font (v) {
      console.log(v)
      if (v === null) {
        this.fontNameInit = 0
      } else {
        for (var o in this.fontList) {
          if (this.fontList[o].value === this.font) {
            this.fontNameInit = this.fontList[o].id
          }
        }
      }
    }
  },
  computed: {
    isText () { return this.type === ES.TYPE_TEXT },
    isLine () { return this.type === ES.TYPE_LINE },
    isBlock () { return this.type === ES.TYPE_BLOCK },
    isImg () { return this.type === ES.TYPE_IMG },
    isTitle () { return this.type === ES.TYPE_TITLE },
    isIndex () { return this.type === ES.TYPE_INDEX },
    isTextOrBlock () { return this.type === ES.TYPE_TEXT || this.type === ES.TYPE_BLOCK },
    isLineOrImg () { return this.type === ES.TYPE_LINE || this.type === ES.TYPE_IMG },
    fontName: {
      get () {
        if (this.font === null) {
          return 0
        } else {
          for (var o in this.fontList) {
            if (this.fontList[o].value === this.font) {
              return this.fontList[o].id
            }
          }
        }
      },
      set (v) { this.$emit('action', 'font', ES.toolFONT, v) }
    },
    fontSize: {
      get () {
        console.log(this.size)
        if (this.type !== ES.TYPE_TEXT || this.size === null) {
          return 1
        } else {
          for (var o in this.fontSizeList) {
            console.log(this.fontSizeList[o].value, this.size)
            if (this.fontSizeList[o].value.toString() === this.size) {
              return this.fontSizeList[o].id
            }
          }
        }
      },
      set (v) {
        console.log('fontSize', v, this.size)
        this.$emit('action', 'size', ES.toolSize, v.toString())
      }
    },
    textAlign: {
      get () { return this.align },
      set (v) { this.$emit('action', 'align', ES.toolAlign, v) }
    },
    isItalic: {
      get () { return this.italic },
      set (v) { this.$emit('action', 'italic', ES.toolITALIC, v) }
    },
    isUnderline: {
      get () { return this.underline },
      set (v) { this.$emit('action', 'underline', ES.toolUNDERLINE, v) }
    },
    isStrike: {
      get () { return this.strike },
      set (v) { this.$emit('action', 'strike', ES.toolSTRIKE, v) }
    },
    isBold: {
      get () { return this.bold },
      set (v) { this.$emit('action', 'bold', ES.toolBOLD, v) }
    },
    isIndent: {
      get () { return this.indent },
      set (v) { this.$emit('action', 'indent', ES.toolINDENT, v) }
    },
    hasForeColor: {
      get () {
        var c = this.foreColor !== null ? this.foreColor : '#000000'
        return {
          'border': '0px',
          'border-bottom': '3px solid ' + c
        }
      },
      set (v) { this.$emit('action', 'foreColor', ES.toolForeCOLOR, v) }
    },
    hasBackColor: {
      get () {
        var s = this.backColor !== null ? this.backColor : '#FFFFFF'
        var c = {
          'background-color': s
        }
        if (parseInt('0x' + s.substring(1, 3)) < 182 && parseInt('0x' + s.substring(3, 5)) < 182 && parseInt('0x' + s.substring(5)) < 182) {
          c.color = '#FFFFFF'
        }
        return c
      },
      set (v) { this.$emit('action', 'backColor', ES.toolBackCOLOR, v) }
    },
    style: {
      get () { return this.editStyle },
      set (v) { this.$emit('action', 'editStyle', ES.toolStyle, v) }
    },
    lineSize: {
      get () { return this.size },
      set (v) { this.$emit('action', 'size', ES.toolSize, v) }
    }
  },
  methods: {
    fontSizeSelect (e) {
      console.log(e)
      this.fontSize = e.param.value
    },
    opencolor (id, e) {
      console.log('open color', id, e)
      var rect = e.target.getBoundingClientRect()
      var prect = this.$el.getBoundingClientRect()
      this.colorStyle = {type: id, x: rect.left - prect.left, y: rect.top + rect.height - prect.top}
    },
    colorSelect (e) {
      console.log('colorSelect', e)
      switch (e.type) {
        case 'txt' :
          this.hasForeColor = e.param
          break
        case 'bg' :
          this.hasBackColor = e.param
          break
        case 'line' :
          this.hasForeColor = e.param
          break
      }
    },
    mousedown (e) {
      if (this.isTarget(e, document.querySelector('.toolbar'))) {
        this.$emit('update:isReFocus', true)
      }
    },
    openLinkPopup () {
      if (this.type === ES.TYPE_LINE) {
        this.alert('구분선은 링크를 걸수 없습니다.')
      } else {
        var s = document.getSelection() || window.getSelection()
        var r, t
        if (this.link) {
          t = document.createRange()
          console.log(closest(s.anchorNode, 'a'), s)
          t.selectNode(closest(s.anchorNode, 'a').childNodes[0])
          r = {
            range: t,
            link: this.link
          }
        } else {
          r = {
            range: (s !== null && s.rangeCount !== 0) ? s.getRangeAt(0) : document.createRange(),
            link: this.link
          }
        }
        this.openPopup('linkpopup', r, (e) => {
          if (e.result) {
            console.log('link popup', e)
            this.$emit('action', null, ES.toolLINK, e.param)
          }
        })
      }
    },
    imageChange (e, file) {
      console.log('imageChange', e, file)
      this.$emit('action', null, ES.toolIMG, file)
      document.querySelector('#imageForm #pimg').value = ''
    }
  },
  components: {
    'editorIconButton': {
      props: {
        icon: {
          type: String
        },
        isActive: {
          type: Boolean
        },
        iconStyle: {
          type: Object
        }
      },
      computed: {
        iconName () {
          return this.icon
        },
        getState () {
          return (this.isActive) ? 'active' : 'deactive'
        }
      },
      template: '<Ubutton size="medium" :icon="iconName" class="cursorButton" iconSize="xsmall"  :state="getState"/>'
    },
    'editorIconLineButton': {
      props: {
        icon: {
          type: String
        },
        isActive: {
          type: Boolean
        },
        iconStyle: {
          type: Object
        }
      },
      template: '<div class="line lineBtn">' +
      '<span :class="icon"/>' +
      '</div>'
    }
  }
}
</script>

<style>
.line {
  display: flex;
  justify-content: center;
}
.line .solid {
  border-bottom: 1px solid;
}
.line .inset {
  border-bottom: 2px solid;
}
.line .dashed {
  border-bottom: 2px dashed;
}
.line .double {
  border-bottom: 4px double;
}
.line .large {
  width: 99%;
}
.line .middle {
  width: 60%;
}
.line .small {
  width: 30%;
}
.lineBtn {
  display: flex;
  align-items: center;
  width: 50px;
  height: 40px;
  padding: 5px;
}
.img {
  display: flex;
  overflow: hidden;
  justify-content: center;
}
.fullImage {
  width: 100%;
  height: 100%;
}
.orgImage {
  margin: 0 auto;
}
.mark_01 {
  border: 1px solid var(--line-base);
  margin: 10px;
  padding: 10px;
}
.mark_02 {
  border-top: 2px solid var(--line-base);
  border-bottom: 2px solid var(--line-base);
  text-align: center;
  margin: 10px;
  padding: 10px;
}
.mark_03 {
  border-left: 10px solid var(--line-base);
  margin: 10px;
  padding: 10px;
}
.mark_04:before {
  color: var(--line-base);
  content:'“';
  font-size: 5em;
  line-height: 0.1em;
  margin-right: 0.25em;
  vertical-align: -0.4em;
}
blockquote.text_left {
  text-align: left;
}
blockquote.text_right {
  text-align: right;
}
blockquote.text_center {
  text-align: center;
}
blockquote.text_justify {
  text-align: justify;
}
font[size='1'] {
  font-size: 0.8em;
}
font[size='2'] {
  font-size: 1em;
}
font[size='3'] {
  font-size: 1.2em;
}
font[size='4'] {
  font-size: 1.4em;
}
</style>

<style scoped>
.toolbar {
  height: 40px;
  width: 100%;
  z-index: 3;
  align-items: center;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: row;
}
.toolbar li {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid var(--line-guide);
}
.editorIconButton {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.editorIconButton div {
  display: flex;
  align-items: baseline;
}
.toolbar-fade-enter-active {
  transition: all .2s ease;
}
.toolbar-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.toolbar-fade-enter, .toolbar-fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/edit/ToolBar.vue